// Hiérarchie de boutons de la charte : primaire (1 max par écran) · secondaire · discret. Source unique pour le Bureau et « Parler à Matthieu ».
export const BOUTON = {
  base: { height: 36, padding: "0 var(--oh-space-4)", borderRadius: "var(--oh-radius-control)", fontSize: 14, fontWeight: 500, cursor: "pointer", lineHeight: 1.6 },
  primaire: { background: "var(--oh-accent-solid)", color: "var(--oh-accent-contrast)", border: "1px solid var(--oh-accent-solid)" },
  secondaire: { background: "transparent", color: "var(--oh-accent-text)", border: "1px solid var(--oh-accent)" },
  discret: { background: "transparent", color: "var(--oh-text-secondary)", border: "1px solid var(--oh-border)" },
};

export default function Bouton({ type = "discret", style, disabled, ...rest }) {
  return (
    <button
      type="button"
      disabled={disabled}
      style={{ ...BOUTON.base, ...BOUTON[type], opacity: disabled ? 0.5 : 1, cursor: disabled ? "not-allowed" : "pointer", ...style }}
      {...rest}
    />
  );
}
